module.exports = __webpack_public_path__ + "static/media/bg-2500.ed19ee83.jpeg";